import React, { useEffect, useState } from "react";
import { Form, Row, Col, Space, Button, Spin } from "antd";
import { InputFields } from "components/common";
import dayjs from "dayjs";
import { useAppSelector } from "../../../../../../redux/hooks";
import { dataFields } from "./config";
import Notification from "../../../../../../components/common/notification/notification";
import employeeService from "api/employee";
import moment from "moment";
import { authenticationService } from "api";

const FormAction = (props) => {
  const {
    closeModal,
    type,
    refreshList = () => {},
    currentRecord = {},
  } = props;

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  // const employees = useAppSelector(state => state.employeesReducer);

  const { ApprovePermissionList = [] } = useAppSelector(
    (state) => state.employeesReducer
  );
  const [fieldValues, setFieldValue] = useState(dataFields);

  useEffect(() => {
    const setOptionsRole = async () => {
      const res = await authenticationService.getListRoleAlina();

      if (fieldValues.find((field) => field.name === "role")) {
        fieldValues.find((field) => field.name === "role").options =
          res?.data.map((item) => ({
            value: item.maSso,
            label: item.name,
          }));
        setFieldValue([...fieldValues]);
      }
    };
    setOptionsRole();
  }, []);

  useEffect(() => {
    if (type === "Thêm") {
      form.resetFields();
      fieldValues.find((field) => field.name === "role").disable = false;
      setFieldValue([...fieldValues]);
    }
    if (currentRecord?.role) {
      const {
        role,
        id_quyen_duyet,
        ghi_chu,
        ngay_hieu_luc,
        ngay_het_hieu_luc,
        trang_thai,
      } = currentRecord;
      form.setFieldsValue({
        role,
        id_quyen_duyet,
        ghi_chu,
        ngay_hieu_luc: dayjs(ngay_hieu_luc),
        ngay_het_hieu_luc: currentRecord?.ngay_het_hieu_luc
          ? dayjs(ngay_het_hieu_luc)
          : null,
        trang_thai,
      });
      fieldValues.find((field) => field.name === "role").disable = true;
      setFieldValue([...fieldValues]);
    }
  }, [currentRecord, type]);

  useEffect(() => {
    if (!ApprovePermissionList.length) {
      const getPermissions = async () => {
        const res = await employeeService.getApprovePermissions({
          page: 1,
          limit: 10,
        });
        console.log(res);
        const perList = res.data.data;

        if (fieldValues.find((field) => field.name === "id_quyen_duyet")) {
          fieldValues.find((field) => field.name === "id_quyen_duyet").options =
            perList?.map((item) => ({
              value: item.id,
              label: item.maQuyenDuyet,
            }));
          setFieldValue([...fieldValues]);
        }
      };
      getPermissions();
    } else {
      fieldValues.find((field) => field.name === "id_quyen_duyet").options =
        ApprovePermissionList?.map((item) => ({
          value: item.id,
          label: item.maQuyenDuyet,
        }));
      setFieldValue([...fieldValues]);
    }
  }, [type, ApprovePermissionList]);

  const addApi = async () => {
    setLoading(true);
    const value = await form.validateFields();
    console.log(value);

    try {
      const payload = {
        ...value,
        ngay_hieu_luc: moment(new Date(value.ngay_hieu_luc)).format(
          "YYYY-MM-DDTHH:mm:ss.SSSSSSZ"
        ),
        ngay_het_hieu_luc: value.ngay_het_hieu_luc
          ? moment(new Date(value.ngay_het_hieu_luc)).format(
              "YYYY-MM-DDTHH:mm:ss.SSSSSSZ"
            )
          : null,
      };
      const res = await employeeService.createApprovePerson(payload);

      if (res.data.code === "400") {
        Notification("warning", res.data.message || "Thêm mới thất bại");
      } else {
        Notification("success", "Đã thêm mới thành công");
        closeModal();
        refreshList();
        form.resetFields();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi thêm mới quyền duyệt");
    }
  };

  const editApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();

    try {
      const payload = {
        ...value,
        ngay_hieu_luc: moment(new Date(value.ngay_hieu_luc)).format(
          "YYYY-MM-DDTHH:mm:ss.SSSSSSZ"
        ),
        ngay_het_hieu_luc:
          value.ngay_het_hieu_luc && value.ngay_het_hieu_luc !== "Invalid date"
            ? moment(new Date(value.ngay_het_hieu_luc)).format(
                "YYYY-MM-DDTHH:mm:ss.SSSSSSZ"
              )
            : null,
      };
      const res = await employeeService.updateApprovePerson(payload);

      if (res.data.code === "400") {
        Notification("warning", res.data.message || "Sửa thất bại");
      } else {
        Notification("success", "Đã sửa thành công");
        closeModal();
        refreshList();
        form.resetFields();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi sửa quyền duyệt");
    }
  };

  const onFinish = () => {
    if (type == "Thêm") {
      addApi();
    } else {
      editApi();
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Row gutter={[16, 8]}>
              <InputFields data={dataFields}></InputFields>
            </Row>
            <div className="container" style={{ marginTop: 12 }}>
              <div className="container-main"></div>
            </div>
            <Row justify="end" style={{ marginTop: 12 }}>
              <Col>
                <Space>
                  <Button
                    onClick={closeModal}
                    style={{
                      backgroundColor: "red",
                      borderColor: "red",
                      color: "white",
                    }}
                  >
                    Hủy bỏ
                  </Button>
                  <Button htmlType="submit" type="primary">
                    Lưu lại
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default FormAction;
